import { axiosInstance } from '@/lib/axios'
import { useLoadingStore } from '@/modules/shared/stores/loadingStore'
const useDayTypesService = () => {
  const startLoading = useLoadingStore((s) => s.startLoading)
  const getPinnedDays = async ({ companyId }: { companyId: string }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(
        `/api/${companyId}/timesheet/pinnedDayTypes`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const addPinDay = async ({
    companyId,
    dayTypeId,
  }: {
    companyId: string
    dayTypeId: number
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/timesheet/pinnedDayTypes`,
        {
          dayTypeId: dayTypeId,
        },
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const removePinDay = async ({
    companyId,
    dayTypeId,
  }: {
    companyId: string
    dayTypeId: number
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.delete(
        `/api/${companyId}/timesheet/pinnedDayTypes/${dayTypeId}`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }

  return { removePinDay, addPinDay, getPinnedDays }
}

export default useDayTypesService
